export default "__VITE_ASSET__dPvkqZQY__"